module.exports = __webpack_public_path__ + "static/media/detection.1bf5f610.png";